import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        /*
        async searchSupplierByString({ querystring, includeInactive }) {
            var meta = {
                clientApiMethod: 'searchSupplierByString',
                input: { querystring: querystring, includeInactive: includeInactive }
            }
            var query ="?searchQuery=" + querystring + "&IncludeInactive=" + includeInactive;
            var response = await client().get(store.state.apiRouteRoot + "Supplier/search" + query, { meta: meta })
            return response.data;
        },
        */
        async getSupplierListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getSupplierListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Supplier/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getSupplierList() {
            var response = await client().get(store.state.apiRouteRoot + 'Supplier', { meta: { clientApiMethod: 'getSupplierList' } })
            return response?.data;
        },
        async getSupplierById(supplierId) {
            var meta = { clientApiMethod: 'getSupplierById', input: { supplierId: supplierId } }
            var response = await client().get(store.state.apiRouteRoot + "Supplier/" + supplierId, { meta: meta })
            return response?.data;
        },
        async createSupplier(newSupplier) {
            var meta = {
                clientApiMethod: 'createSupplier',
                input: { newSupplier },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.supplier.supplier") })
            }
            var response = await client().post(store.state.apiRouteRoot + 'Supplier', newSupplier, { meta: meta })
            return response?.data;
        },
        async updateSupplier(updatedSupplier) {
            var meta = {
                clientApiMethod: 'updateSupplier',
                input: { updatedSupplier },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.supplier.supplier") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'Supplier', updatedSupplier, { meta: meta })
            return response?.data;
        },
    }
}